// extracted by mini-css-extract-plugin
export var critical = "statusIndicator-module--critical--33def";
export var indicator = "statusIndicator-module--indicator--1e818";
export var indicatorLink = "statusIndicator-module--indicatorLink--cd727";
export var klaviyoStatusIndicator = "statusIndicator-module--klaviyoStatusIndicator--bc063";
export var maintenance = "statusIndicator-module--maintenance--ca09e";
export var major = "statusIndicator-module--major--856cb";
export var minor = "statusIndicator-module--minor--eeb98";
export var none = "statusIndicator-module--none--db24a";
export var statusText = "statusIndicator-module--statusText--1abf4";